import { render, staticRenderFns } from "./ProjectInfoBlock.vue?vue&type=template&id=0a446c72"
import script from "./ProjectInfoBlock.vue?vue&type=script&lang=js"
export * from "./ProjectInfoBlock.vue?vue&type=script&lang=js"
import style0 from "./ProjectInfoBlock.vue?vue&type=style&index=0&id=0a446c72&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports